
const config = {
    version: '0.1.0',
    serverUrl:process.env.REACT_APP_SERVER_URL,
    s3Url:process.env.REACT_APP_S3_STATIC_CONTENT_URL,
}

export default config;